module.exports = __webpack_public_path__ + "img/ad3.24158df2.png";